import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import { easing, physics, styler, tween } from 'popmotion';
import { Styler } from 'stylefire/lib/styler/types';

/**
 * TODO Migrate this component to a newer version of popmotion or rewrite it using
 *
 *  or just CSS https://codepen.io/scottloway/pen/zqoLyQ
 *
 */
@Component({
  selector: 'app-success-spinner',
  templateUrl: './success-spinner.component.html',
  styleUrls: ['./success-spinner.component.scss']
})
export class SuccessSpinnerComponent implements OnInit, AfterViewInit {
  @ViewChild('tickOutlinePath', {static: false}) tickOutlinePath;
  @ViewChild('tickPath', {static: false}) tickPath;

  isActive = false;

  private circleStyler: Styler;
  private tickStyler: Styler;

  private hideSpinnerTimeout;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.circleStyler = styler(this.tickOutlinePath.nativeElement);
    this.tickStyler = styler(this.tickPath.nativeElement);
  }

  showSpinner() {
    if (this.isActive) {
      return;
    }

    this.circleStyler.set('opacity', 0);
    this.tickStyler.set('opacity', 0);

    this.tickStyler.set('rotate', 0);

    clearTimeout(this.hideSpinnerTimeout);

    this.isActive = true;

    tween({ease: easing.easeIn}).start({
      update: (v) => this.circleStyler.set({
        opacity: v,
        pathLength: v * 0.45
      }),
      complete: () => physics({velocity: -400})
        .while(() => this.isActive)
        .start(v => this.circleStyler.set('rotate', v))
    });
  }

  showTick() {
    if (!this.isActive) {
      return;
    }

    tween({
      from: this.circleStyler.get('pathLength'),
      to: 1
    }).start({
      update: (v) => this.circleStyler.set('pathLength', v),
      complete: () => {
        this.circleStyler.set('rotate', 0);
        this.isActive = false;
      }
    });

    tween().start((v) => this.tickStyler.set({
      opacity: v,
      pathLength: v
    }));

    this.hideSpinnerTimeout = setTimeout(() =>
      tween({from: 1, to: 0, ease: easing.easeOut})
        .start(v => {
          this.circleStyler.set('opacity', v);
          this.tickStyler.set('opacity', v);
        }), 2000);
  }

  hideSpinner() {
    if (!this.isActive) {
      return;
    }

    tween({from: 1, to: 0, ease: easing.easeOut})
      .start(v => {
        this.circleStyler.set('opacity', v);
      });
  }
}
